export default {
    label_task:{
        en:"Sales Report",
        bn:'Variety Report'
    },
    label_fiscal_year :{
        en:"Fiscal Year",
        bn:'ব্যবহারকারীরা'
    },
    label_num_fiscal_years :{
        en:"Num of Fiscal Year",
        bn:'ব্যবহারকারীরা'
    },
    label_num_months :{
        en:"Num of Months",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_net:{
        en:"Net Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_gross:{
        en:"Gross Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_cancel:{
        en:"Canceled Sales",
        bn:'ব্যবহারকারীরা'
    },
}